module.exports = __webpack_public_path__ + "static/media/11.754b8257.jpg";